 module.exports = function(bootstrap) {
     bootstrap.run(["services", "Service", "$filter", "session","xml2json", function (services, Service, $filter, session,xml2json) {
         new Service({
             name: 'openAttachment',
             group: "mhsimb",
             url: "/mhsimb/x-services/secureMessage/attachment",
             contentType: 'application/xml',
             addFile:function(fileBinary,fileName){

                 var formData = {
                     "attachmentRequestMessage": {
                         "baseMessage": {
                             "exchangeType": "SENDREQUEST",
                             "headerVersion": "2.2",
                             "username": "appmhs",
                             "businessProcessDifferentiatorId": [
                                 "1"
                             ]
                         },
                         "payload": {
                             "Profile": "MCEDS000Store.properties",
                             "EMLFilename": fileName,
                             "Instream": fileBinary
                         }
                     }
                 };

                 formData = xml2json.json2xml_str(formData);
                 return this.post(formData);


             }
         });
     }]);

 }